module.exports = __webpack_public_path__ + "static/media/sleigh.0f32e2ae.svg";